import { createContext, useContext, useMemo } from 'react';

/**
 * N2 (T5, DC-18 option a): true inside a list's filters sheet (FiltersDialog,
 * below md only). A select there shows the existing "all" label as its
 * placeholder under an always-raised label (filters-dialog/index.module.scss):
 * an empty filter reads "all" instead of an empty row under its label.
 */
export const FiltersSheetContext = createContext(false);

export const useIsInFiltersSheet = (): boolean => useContext(FiltersSheetContext);

/** The placeholder key of a select in the sheet (`AppSelect` keeps a caller's own). */
export const FILTERS_SHEET_PLACEHOLDER_KEY = 'all';

/**
 * A grid select filter's AurionCR `settings` with the sheet's placeholder:
 * AurionCR's Select reads its placeholder from `settings` only. (No select
 * filter config sets its own placeholder; only the date filters do.)
 */
export const useFiltersSheetSettings = <T extends object | null | undefined>(settings: T): T => {
  const isInFiltersSheet = useIsInFiltersSheet();
  return useMemo(
    () =>
      isInFiltersSheet && settings
        ? { ...settings, placeholder: FILTERS_SHEET_PLACEHOLDER_KEY }
        : settings,
    [isInFiltersSheet, settings],
  );
};
